import { CREATE } from 'react-admin';
export const FORM_DATA = 'FORM_DATA';

import * as constants from '../../constants/index';
import {
    REESTABLISH_REQUEST,
    REESTABLISH_REQUEST_CLEAR,
    REESTABLISH_FLIGHTS_REQUEST,
    REESTABLISH_FLIGHTS_REQUEST_CLEAR,
    REESTABLISH_FLIGHTS_AFTER_REJECTION,
    REESTABLISH_FLIGHTS_AFTER_REJECTION_CLEAR 
} from './types';

export const reEstablishRequest = (data: any) => ({
    type: REESTABLISH_REQUEST,
    payload: { data: { flightRequest: data } },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.REESTABLISH_REQUEST}`,
    },
});

export const reEstablishFlights = (data: any) => ({
    type: REESTABLISH_FLIGHTS_REQUEST,
    payload: { data: data },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.REESTABLISH_FLIGHTS}`,
    },
});

export const reEstablishFlightsAfterRejection = (data: any) => ({
    type: REESTABLISH_FLIGHTS_REQUEST,
    payload: { data: data },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.REESTABLISH_REQUEST_AFTER_REJECTION}`,
    },
});


export const clearReEstablishRequest = () => ({
    type: REESTABLISH_REQUEST_CLEAR,
    payload: [],
});

export const clearReEstablishFlights = () => ({
    type: REESTABLISH_FLIGHTS_REQUEST_CLEAR,
    payload: { data: { result: false } },
});

export const clearReEstablishFlightsAfterRejection = () => ({
    type: REESTABLISH_FLIGHTS_AFTER_REJECTION_CLEAR,
    payload: { data: { result: false } },
});
